import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
  Grid,
  GridColumn as Column,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
  getSelectedState,
  GridCellProps,GridNoRecords
} from '@progress/kendo-react-grid';
import { getter } from '@progress/kendo-react-common';
import { useEffect, useState } from 'react';
import { checkAvailability } from "../../utils/EllowUtils";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import PopupMenu from "../popupmenu";
import { Link } from "react-router-dom";
import { DropDown } from "./dropdownTimesheet";

import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";

const DATA_ITEM_KEY: string = 'timesheetId';
const SELECTED_FIELD: string = 'selected';

const idGetter = getter(DATA_ITEM_KEY);

const PositionTable = (props: any) => {

  const [dataState, setDataState] = useState(props.data && props.data.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem)
  ));
    
  const [selectedState, setSelectedState] = useState<{
    [id: string]: boolean | number[];
  }>({});

  const [selectedCandidates, setSelectedCandidates] = useState<{ name: string, timesheetId: string}[]>([]);

  useEffect(() => {
    setSelectedState(props.selectedState)
    setDataState(props.data && props.data.map((dataItem: any) =>
      Object.assign({ selected: false }, dataItem)
    ))

  }, [props.data])




  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);
      let newCandidatesArray: any =  []
      if (!event.dataItem.selected) {
        let newCandidatesArray = [...selectedCandidates, event.dataItem]
        setSelectedCandidates(newCandidatesArray)
        props.onSelection(newCandidatesArray)
      } else {
        const index = selectedCandidates.findIndex(item => item.timesheetId === event.dataItem.timesheetId);;
        if (index > -1) {
          newCandidatesArray = selectedCandidates.filter(item => item.timesheetId !== event.dataItem.timesheetId)        
        }
        setSelectedCandidates(newCandidatesArray)
        props.onSelection(newCandidatesArray)
      }

    },
    [selectedState]
  );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: any = {};

      event.dataItems.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      })
      setSelectedState(newSelectedState);
      let candidates = []
      if (checked) {
        candidates = event.dataItems
      } else {
        candidates = []
      }
      props.onSelection(candidates)
    },
    []
  );

  const sendReminder = ( item: any) => {
    props.sendReminder(item)
  }

  const buttonClick = (data: any) => {
    // if (data.timesheetStatus === '1') {
    //     props.sendReminder(data)
    // }
    // else
    // {
    localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(data))
    openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
  //  }
  }

  const viewButton = (event: GridCellProps) => {   
    
    const handleChange = (data: any) => {   
      switch (data.target.text) {
        case 'Upload':
          localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(event.dataItem))
          openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
          return
        case 'Send Reminder to customer':
          sendReminder(event.dataItem)
          return
        case 'Send Reminder to candidate':
          sendReminder(event.dataItem)
          return
        case 'View':
          localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(event.dataItem))
          openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
          return
        case 'Edit':
          localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(event.dataItem))
          openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
      }
    }
    
    return (
      <td>
        {event.dataItem.timesheetStatus !== '3' ?
          // <DropDownList data={event.dataItem.timesheetStatus === '1' ? dropDownValues1 : dropDownValues2} onChange={handleChange} />
          <PopupMenu>
            <div className='popupLinks'>
              <Link to='' onClick={handleChange}>{event.dataItem.timesheetStatus === '1' ? 'Upload' : 'View' }</Link>
              <Link to='' onClick={handleChange}>{event.dataItem.timesheetStatus === '2' ? 'Send Reminder to customer' :  event.dataItem.timesheetStatus === '1' ? 'Send Reminder to candidate' : 'Edit' }</Link>
            </div>
          </PopupMenu>
          : 
        <div style={{ 'color': '#14A800'}} className="cursor"  onClick={() => buttonClick(event.dataItem)}>View</div>}
      </td>
    );
  };

  const getTableValues = () => {
    props.getTables()
  }

  const historyCell = (event: GridCellProps) => {
    return (
        <td>
            <Link to={''} onClick={() => props.showHistory(event.dataItem)}><Icon icon="bx:history"width="25" style={{'color':'rgba(0, 0, 0, 0.6)'}} ></Icon></Link>
        </td>
    )
  }

  return (

      <Grid
        data={dataState && dataState.map((item: any) => ({
          ...item,
          [SELECTED_FIELD]: selectedState[idGetter(item)],
        }))}
        dataItemKey={DATA_ITEM_KEY}
        selectedField={SELECTED_FIELD}
        selectable={{
          enabled: true,
          drag: false,
          cell: false,
          mode: 'multiple',
        }}
        onSelectionChange={onSelectionChange}
        onHeaderSelectionChange={onHeaderSelectionChange}
        onPageChange={props.pageChange}
        total={props.total}
        skip={props.state.skip}
        pageable={props.state.pageable}
        pageSize={props.state.pageSize}
        onItemChange={props.itemChange}
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column
          field={SELECTED_FIELD}
          width="50px"
          headerSelectionValue={
            dataState && dataState.findIndex((item: any) => !selectedState[idGetter(item)]) === -1
          }
        />
        <Column  title="Name" cell={nameCell}  width="180px"/>
        <Column field="duration" title="Duration" cell={durationCell} />
        <Column field="position" title="JobRole" />
        <Column field="companyName" title="Company"  />
        <Column field="actualWorkingDays" title="Actual working days"  cell={actualWorkingDaysCell}/>
        <Column field="leaves" title="Leaves" cell={leaveCell}  width="65px"/>
        <Column field="Submitted on" title="Submitted on" cell={submittedCell}/>
        <Column field="status" title="Status" cell={statusCell} width="70px"/>
        <Column field="verifiedBy" title="Verified by"  className="wordBreak"/>
        <Column field="invoiceRaisedStatus" title="Invoice raised"  cell={(props: GridCellProps) => DropDown(props, () => getTableValues())}/>
        <Column cell={historyCell} width="50px"/>
        <Column cell={viewButton} />
      </Grid>

  );
};

export default PositionTable;

const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };



const statusCell = (props: GridCellProps) => {
  
    return (
        <td>
            <div className={checkStatus(props.dataItem.timesheetStatus).class}>
           {checkStatus(props.dataItem.timesheetStatus).value}
        </div>
        </td>
    )
  }



  const checkStatus = (status: string) => {
    switch (status) {
      case '1':
        return {
          value: 'Draft',
          class: 'statusMessage Gray'
        }
      case '2':
        return {
          value: 'Submitted',
          class: 'statusMessage Yellow'
        }
      case '3':
        return {
          value: 'Approved',
          class: 'statusMessage Green'
        }
      case '4':
        return {
          value: 'Rejected',
          class: 'statusMessage Red'
      }
      default:
        return {
          value: '',
          class: ''
      }
    }
  }


  const nameCell = (props: GridCellProps, redirection: any) => {
  
    let currentDate = new Date().getTime()
    let dateOfRegistration = props.dataItem.createdOn
    var diff =(currentDate -  dateOfRegistration) / 1000;
    diff /= (60 * 60);
    let diff2 = Math.abs(Math.round(diff));
    
    const profileImage = props.dataItem.googleProfileImage ?  props.dataItem.googleProfileImage : " " 
    let name = props.dataItem && props.dataItem.candidateName && props.dataItem.candidateName.split(" ")
    let lastName = name && name[1]
 
    return (
      <td className="statusWrap">
      {diff2 <= 24 &&
        <span className="userStatus">New</span>
      }
      <div className="userInfo" >
        <div className="stroke-wrapper"> 
  
          {profileImage === " "? 
           <figure >{props.dataItem && props.dataItem.candidateName && props.dataItem.candidateName[0]}{lastName && lastName[0]}</figure>
          :
          <figure><img src={ profileImage }></img></figure> 
          }
          </div>
          <div onClick={() => redirection(props.dataItem.loginId)}>
          {props.dataItem.candidateName}
          <div className="email">{props.dataItem.email}</div>
          <div className="phone">{props.dataItem.phoneNumber}</div>
          </div>
      </div>
    </td>
    )
  }

  const durationCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.startDate && new Date(parseInt(props.dataItem.startDate)).toDateString().slice(3) + " - " + new Date(parseInt(props.dataItem.endDate)).toDateString().slice(3)}
      </td>
    )
  }

  const actualWorkingDaysCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.actualWorkingDays}
      </td>
    )
  }
  
  const leaveCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.leaves}
      </td>
    )
  }
  
  const submittedCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.submittedOn && new Date(parseInt(props.dataItem.submittedOn)).toDateString().slice(3)}
      </td>
    )
  }
  
  const invoiceRaisedCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.invoiceRaisedDate}
      </td>
    )
  }

// const experienceCell = (props: GridCellProps) => {
//   if (props.dataItem.experience !== null) {
//     return <td>{props.dataItem.experience + " Years"}</td>;
//   } else {
//     return <td>{"Not Mentioned"}</td>;
//   }
// };

// const availablityCell = (props: GridCellProps) => {

//   let data = {
//     availability: props.dataItem.availability,
//     availability_date: props.dataItem.availability_date,
//     availability_week: props.dataItem.availability_week
//   }

//   return <td>{checkAvailability(data)}</td>
// }

// const emailCell = (props: GridCellProps) => {

//   return(
//     <td className='wordBreak'>{props.dataItem.email}</td>
//   )
// }

// const expectedPayCell = (props: GridCellProps) => {

//   return(
//     <td>{props.dataItem.rates !== null ? props.dataItem.rates +' '+ props.dataItem.currencyType + '/' + props.dataItem.billingType : 'Not Mentioned'}</td>
//   )
// }

// const skillsCell = (props: GridCellProps) => {

//   let length = props.dataItem.skills && props.dataItem.skills.length;

//   return (
//     <td >
//       <div className="skillsWrap">
//         {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number) => {
//           return ((item) + (key < length - 1 ? ' , ' : ''))
//         })}
//       </div>
//     </td>
//   );
// };

// const dateCell = (props: GridCellProps) => {
//   let dateNumber = parseInt(props.dataItem.dateOfRegistration);
//   let date = new Date(dateNumber).toDateString();

//   return <td><div className="dateWrap">{date}</div></td>;
// };

// const nameCell = (props: GridCellProps, redirection: any) => {

//   return (
//     <td onClick={() => redirection(props.dataItem.loginId)} className="pointer">
//       {props.dataItem.name}
//     </td>
//   );
// };

// const sourcedByCell = (props: GridCellProps) => {
//   return (
//     <td >
//       {props.dataItem.sourcedBy}
//     </td>
//   );
// };

// const certificationsCell = (props: GridCellProps,) => {
//   return (
//     <td >
//       {props.dataItem.certifications}
//     </td>
//   );
// };
// const ellowStatusCell = (props: GridCellProps,) => {
//   return (
//     <td >
//       {props.dataItem.ellowStatus}
//     </td>
//   );
// };
// const allocatedToCell = (props: GridCellProps,) => {
//   return (
//     <td >
//       {props.dataItem.allocatedTo}
//     </td>
//   );
// };
